import React, { Component } from 'react';

import PropTypes from 'prop-types';
import cx from 'classnames';
import { Link } from "react-router-dom";

function RightArrow() {
    return (
        <svg width="17" height="28" viewBox="0 0 17 28" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(-391.000000, -124.000000)" fill="#FFFFFF">
                    <g transform="translate(394.142136, 138.142136) rotate(-315.000000) translate(-394.142136, -138.142136) translate(384.142136, 128.142136)">
                        <rect x="-2.27373675e-13" y="-1.13686838e-13" width="19.5226344" height="3.48769053"></rect>
                        <polygon points="16.4683385 19.3866021 16.4683385 0.553073235 19.956029 0.553073235 19.956029 19.3866021"></polygon>
                    </g>
                </g>
            </g>
        </svg>
    )
}


class UpNext extends Component {
    constructor(props) {
        super(props);
        require('./up-next.scss');
        this.linkRef = React.createRef();
        //console.log("[UpNext] props:",props);
    }
    handleClick(e) {
        this.props.onClick(this.linkRef.current);
    }

    render() {
        const { show, title, isIfi, episodeTag, path } = this.props;
        if (show == false) {
            return null;
        } else {
            const classes = cx({
                "up-next": true,
                "ifi": isIfi

            })
            let tag = isIfi ? "Information From Industry" : episodeTag;
            return (
                <Link className={classes} to={path} onClick={this.handleClick.bind(this)}>
                    <div className="content">
                        <div>
                            <h4>Up Next</h4>
                            <div className="tag">{ tag }</div>
                            <div className="title" dangerouslySetInnerHTML={{__html: title} } ></div>
                        </div>
                    </div>
                    <div className="arrow">
                        <div><RightArrow /></div>
                    </div>
                </Link>
            )
        }
    }
    static get propTypes() {
        return {
            show: PropTypes.bool,
            title: PropTypes.string,
            isIfi: PropTypes.bool,
            episodeTag: PropTypes.string,
            path: PropTypes.string,
            onClick: PropTypes.func
        }
    }

    static get defaultProps() {
        return {
            show: false,
            title: "",
            isIfi: false,
            episodeTag: "",
            path: "",
            onClick: () => {}
        }
    }
}



export default UpNext;